import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { NewsCard, NewsCardSkeleton } from "@/components/NewsCard";

export const SpaceNewsSection = ({ loading, news }) => (
  <section>
    <div className="flex items-center justify-between mb-4">
      <h2 className="section-title">Space News</h2>
      <Link
        to="/news"
        className="text-sm text-cosmic-blue hover:text-cosmic-blue-glow font-heading font-semibold uppercase tracking-wider flex items-center gap-1"
        style={{ transition: "color 0.2s ease" }}
        data-testid="view-all-news"
      >
        View All
        <ChevronRight className="w-4 h-4" strokeWidth={1.5} />
      </Link>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {loading ? (
        <>
          <NewsCardSkeleton compact />
          <NewsCardSkeleton compact />
          <NewsCardSkeleton compact />
          <NewsCardSkeleton compact />
        </>
      ) : news?.length > 0 ? (
        news.map((article) => (
          <NewsCard key={article.id} article={article} compact />
        ))
      ) : (
        <div className="glass-card p-6 text-center col-span-2">
          <p className="text-slate-400">No news available</p>
        </div>
      )}
    </div>
  </section>
);
